import script from "./ExpandedProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandedProfile.vue?vue&type=script&setup=true&lang=ts"

import "./ExpandedProfile.vue?vue&type=style&index=0&id=6f1368d3&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1368d3"]])

export default __exports__